import { render } from "./DividendDetailModal.vue?vue&type=template&id=0419ada1&ts=true"
import script from "./DividendDetailModal.vue?vue&type=script&lang=ts"
export * from "./DividendDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__